<div class="title">
  <div class="text-title">
    <div id="titre">
      <div>
        <div><b>Espace client</b></div>
        <div id="etoiles">
          <img src="/assets/pictogrammes/etoiles.svg" />
        </div>
      </div>
    </div>
    <div id="subtitle">
      <div>
        <div>Connectez-vous à votre espace client</div>
        <div id="globe">
          <img src="/assets/pictogrammes/globe.svg" />
        </div>
      </div>
    </div>
  </div>
  <div class="wave">
    <img src="/assets/img/wave.svg" />
  </div>
</div>

<div class="page">
  <h1>Demande de réinitialisation<br /> <span class="color-title">de mot de passe</span></h1>
  <div class="form">
    <div class="icon-connexion">
      <img src="/assets/pictogrammes/login.svg" />
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="form-connexion">
      <mat-card class="mat-elevation-z">
        <mat-form-field>
          <input mat-input matInput formControlName="username" placeholder="Identifiant" autocomplete="off">
          <mat-error *ngIf="form.hasError('required',['username'])">L'identifiant est requis</mat-error>
        </mat-form-field>

        <button type="submit" mat-raised-button color="primary" class="btn">Demander une réinitialisation</button>
        <a routerLink="/login" class="link">> S'identifier</a>
      </mat-card>
    </form>
  </div>
</div>